import { useState } from "react";
import { tx } from "@/i18n";

// Per-taak wisselen tussen automatische vertaling en origineel.
export const useOriginals = () => {
  const [ids, setIds] = useState(() => new Set());
  const isOrig = (t) => ids.has(t.id);
  const toggle = (t) => setIds((prev) => { const n = new Set(prev); n.has(t.id) ? n.delete(t.id) : n.add(t.id); return n; });
  const show = (t, f) => (isOrig(t) && t[`${f}_original`] != null ? t[`${f}_original`] : t[f]);
  const sub = (t, s) => (isOrig(t) && s.name_original ? s.name_original : s.name);
  return { isOrig, toggle, show, sub };
};

export const OrigToggle = ({ t, o }) => (!t.translated ? null : (
  <span className="block text-[11px] text-muted-foreground mt-0.5">
    {tx("Vertaald")} ·{" "}
    <span role="button" tabIndex={0} onClick={(e) => { e.stopPropagation(); o.toggle(t); }}
      onKeyDown={(e) => e.key === "Enter" && o.toggle(t)}
      className="underline underline-offset-2 hover:text-foreground cursor-pointer" data-testid={`task-original-toggle-${t.id}`}>
      {o.isOrig(t) ? tx("Toon vertaling") : tx("Toon origineel")}
    </span>
  </span>
));
